export default __webpack_public_path__ + "static/media/1516.dad64629.png";